<template>
  <div v-if="booking">
    <vs-tabs>
      <vs-tab label="Booking">
        <vs-row
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
          class="editing-booking-popup-content "
        >
          <vs-col class="left-side" vs-sm="12" vs-lg="7">
            <vs-row class="p-4 booking-section rounded text-sm">
              <vs-col vs-w="6">
                <customer-info
                  v-if="bookingCustomer"
                  v-model="bookingCustomer"
                  :disable-component="
                     editingMode === EDITING_MODE.Update && !this.bookingCustomer.isNewCustomer||
                    !hasPermissionForActiveVenue(
                      'vp.vp.booking.createbookings'
                    )
                  "
                />
                <div v-if="bookingCustomer">
                  <p class="mt-3">Message from customer:</p>
                  <p>
                    "<b>{{ booking.customerMessage }}</b
                    >"
                  </p>
                </div>
                <div v-if="!bookingCustomer">
                  No customer added to this booking.
                 <vs-button v-if="!bookingCustomer" @click="addCustomer" size="small" class="mt-2" >Add customer</vs-button>

                </div>
              </vs-col>
              <vs-col vs-w="6">
                <state-and-actions
                  v-if="booking && editingMode != EDITING_MODE.Create"
                  v-model="booking"
                />
              </vs-col>
              <p class="hidden"> {{showPop}}</p>
            </vs-row>

            <vs-row class="p-3 booking-section mt-2 rounded" vs-w="12">
              <vs-col>
                <booking-info
                  v-model="booking"
                  :initial-table="reservedTable"
                  :initial-table-parts="reservedTableParts"
                  :initial-minimum-spend-amount="minimumSpendAmount"
                  :disable-component="!permissionsGranted"
                  @section-selected="handleSectionSelected($event)"
                  @setup-selected="handleSetupSelected($event)"
                  @venue-selected="handleVenueSelected($event)"
                />
              </vs-col>
            </vs-row>

            <vs-row class="p-3 booking-section mt-4 rounded">
              <vs-col>
                <theme-tag-selector
                  v-model="booking"
                  :section="selectedSection"
                  :disable-component="!permissionsGranted"
                />
              </vs-col>
            </vs-row>

            <vs-row vs-w="12">
              <vs-collapse class="w-full">
                <vs-collapse-item
                  disabled
                  v-if="!obsInfo || obsInfo.length === 0"
                >
                  <div slot="header">Obs Info - nothing to show</div>
                </vs-collapse-item>
                <vs-collapse-item v-if="obsInfo && obsInfo.length > 0">
                  <div slot="header">Obs Info</div>
                  <ul>
                    <li
                      v-for="(obsInfoItem, index) in obsInfo"
                      :key="'obsInfoItem' + index"
                    >
                      {{ obsInfoItem.key + ": " + obsInfoItem.value }}
                    </li>
                  </ul>
                </vs-collapse-item>
              </vs-collapse>
            </vs-row>
          </vs-col>

          <vs-col class="right-side" vs-lg="5" vs-sm="12">
            <vs-row class="p-4 booking-section rounded text-sm">
                <booking-host
              v-model="booking"
              @is-adding-note-changed="handleIsAddingNoteChanged($event)"
              :disable-component="!permissionsGranted"
              />
            </vs-row>
            <vs-row class="p-4 booking-section rounded text-sm">
              <booking-notes
                v-model="booking"
                :disable-component="!permissionsGranted"
              />

            
            </vs-row>
            
         
            <products-selector
              v-model="booking"
              :venue-setup="selectedSetup"
              @editing-order-lines-changed="
                handleEditingOrderLinesChanged($event)
              "
              :disable-component="!permissionsGranted"
            />
            <budget-auction
              v-if="bookingRequireBudget"
              :booking="booking"
              @select-booking="updateBooking($event)"
              :disable-component="!permissionsGranted"
            ></budget-auction>
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" vs-type="flex" vs-justify="flex-end">
          <div class="mr-auto mt-auto">
             <p :style="'color: lightgrey'"> <small>Added by: {{createdBy()}} </small></p>
             <p :style="'color: lightgrey'"> <small >{{createdDate()}} </small></p>
          </div>
          <vs-button
            v-if="booking"
            class="mr-2 "
            type="filled"
            color="primary"
            :disabled="
              isEditingOrderLines ||
              isAddingNote ||
              !validForm ||
              !permissionsGranted
            "
            @click="handleSaveBookingClick"
          >
            Save {{ booking.isRequest() ? "Request" : "Booking" }}
          </vs-button>
          <vs-button
            v-if="booking && booking.isRequest()"
            class="mr-2"
            type="filled"
            color="green"
            :disabled="
              isEditingOrderLines ||
              isAddingNote ||
              !validForm ||
              (!booking.venueTableId && !booking.isForEvent()) ||
              !hasPermissionForActiveVenue(
                'vp.vp.booking.editbookings'
              ) ||
              !hasPermissionForActiveVenue(
                'vp.vp.booking.acceptrequestpendingrequests'
              )
            "
            @click="handleAcceptRequestClick"
          >
            Accept Request
          </vs-button>
          <vs-button
            v-if="booking && booking.isRequest()"
            type="filled"
            color="danger"
            @click="handleRejectRequestClick"
            :disabled="
              !hasPermissionForActiveVenue(
                'vp.vp.booking.editbookings'
              ) ||
              !hasPermissionForActiveVenue(
                'vp.vp.booking.acceptrequestpendingrequests'
              )
            "
          >
            Reject Request
          </vs-button>
        </vs-row>

        <popup-booking-policies-warning
          v-if="
            hasPermissionForActiveVenue(
              'vp.vp.booking.editbookings'
            )
          "
          ref="popupBookingPoliciesWarning"
          @booking-accepted="handleBookingWithWarningsAccepted"
          @booking-rejected="handleBookingWithWarningsRejected"
        />

        <vs-popup
          v-if="
            booking &&
            booking.isRequest() &&
            hasPermissionForActiveVenue(
              'vp.vp.booking.acceptrequestpendingrequests'
            )
          "
          title="Confirm Reject Request"
          class="confirm-reject-request-popup"
          :active.sync="showConfirmRejectRequestPopup"
        >
          <vs-row vs-w="12">
            <vs-col vs-w="12">
              <p>Are you sure you want to reject this request?</p>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" vs-type="flex" vs-justify="flex-end">
            <vs-button
              class="mr-2"
              type="filled"
              color="primary"
              @click="handleConfirmRejectRequestClick"
            >
              Confirm
            </vs-button>
            <vs-button
              type="border"
              color="primary"
              @click="handleCancelRejectRequestClick"
            >
              Cancel
            </vs-button>
          </vs-row>
        </vs-popup>
      </vs-tab>
      <vs-tab
        label="Log"
        v-if="booking.changeLog && booking.changeLog.length > 0"
        class="log-content"
      >
        <booking-change-log :booking="booking" />
      </vs-tab>
    </vs-tabs>
       <popup-on-arrival
      v-if="
        hasPermissionForActiveVenue(
          'vp.vp.booking.handleguestlistrequests'
        )
      "
      ref="PopupOnArrivalBooking"
      @update-guest-arrival-count="handlePartialGuestArrival"
      
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  ACTIONS as BOOKING_ACTIONS,
  QueryCommandFactory,
} from "@/store/modules/marcom/marcom-booking";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import moment from "moment";
import * as _ from "lodash";

import {
  BOOKING_STATE,
  ARRIVAL_STATE,
  Booking,
  BookingCustomer,
} from "@/store/modules/marcom/data-model/bookings";
import { ChangeArrivalStateCommand } from "@/store/modules/marcom/data-model/bookings/queries-and-commands/change-arrival-state-command.js";
import PopupBookingPoliciesWarning from "../../PopupBookingPoliciesWarning.vue";
import { POLICY_LIMIT_TYPE } from "@/store/modules/marcom/data-model/policy-configurations";
import CustomerInfo from "./components/CustomerInfo.vue";
import BookingInfo from "./components/BookingInfo/BookingInfo.vue";
import ThemeTagSelector from "./components/ThemeTagSelector.vue";
import ProductsSelector from "./components/ProductsSelector.vue";
import StateAndActions from "./components/StateAndActions.vue";
import BudgetAuction from "./components/BudgetAuction.vue";
import BookingNotes from "./components/BookingNotes.vue";
import BookingChangeLog from "./components/BookingChangeLog.vue";
import BookingHost from "./components/BookingHost.vue"
import PopupOnArrival from "../../PopupPartialArrivalBooking.vue";

import {
  VenueSection,
  VenueTable,
} from "@/store/modules/marcom/data-model/venue-details";

export class EDITING_MODE {
  static Create = "create";
  static Update = "update";
}

export default {
  components: {
    PopupBookingPoliciesWarning,
    CustomerInfo,
    BookingInfo,
    ThemeTagSelector,
    ProductsSelector,
    StateAndActions,
    BudgetAuction,
    BookingNotes,
    PopupOnArrival,
    BookingChangeLog,
    BookingHost
  },
  props: {
    venueDetails: Object,
    editingMode: String,
  },
  data() {
    return {
      EDITING_MODE,
      booking: undefined,
      bookingCustomer: undefined,
      minimumSpendAmount: undefined,
      reservedTable: undefined,
      reservedTableParts: [],

      selectedVenue: null,
      selectedSetup: null,
      selectedSection: null,

      isEditingOrderLines: false,
      isAddingNote: false,
      showConfirmRejectRequestPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      venues: "marcom/venues",
    }),
    validForm() {
      console.log("validForm",this.validBookingInfo && (this.bookingCustomer ? this.validBookingCustomerInfo : true))
      return this.validBookingInfo && (this.bookingCustomer ? this.validBookingCustomerInfo : true);
    },
    showPop(){
      if(this.booking.arrivalState == 12){
      this.$refs.PopupOnArrivalBooking.show(this.booking);
      }
      return this.booking.arrivalState == 12
    },
    validBookingCustomerInfo() {
      console.log("validBookingCustomerInfo",this.bookingCustomer && this.bookingCustomer.isValid())
      return this.bookingCustomer && this.bookingCustomer.isValid();
    },
    validBookingInfo() {
      console.log("validBookingInfo",this.booking && this.booking.isValid())
      return this.booking && this.booking.isValid();
    },

    obsInfo() {
      if (!this.selectedVenue || !this.selectedVenue.obsInfo) return [];

      return _.keys(this.selectedVenue.obsInfo).map((key) => {
        return { key: key, value: this.selectedVenue.obsInfo[key] };
      });
    },
    bookingRequireBudget() {
      var section = this.selectedSection;
      if (section) return section.bookingRequireBudget;
      return false;
    },
  },
  methods: {
    async createBooking(isWalkIn, date) {
      let booking = new Booking();
      booking.venueDetailsId = this.venueDetails.venueDetailsId;
      this.selectedVenue = this.venueDetails;
      booking.bookingState = BOOKING_STATE.VenueConfirmed;
      if (isWalkIn) booking.setAsWalkIn();
      let bookingCustomer = new BookingCustomer();
      booking.guestCount = 2;
      booking.arrival = moment(date).toJSON();

      this.bookingCustomer = bookingCustomer;
      this.booking = booking;

      await this.setSelectedSetup();
    },
    async createBookingWithTable(isWalkIn, date, setup, section, table) {
      let booking = new Booking();
      booking.venueDetailsId = this.venueDetails.venueDetailsId;
      this.selectedVenue = this.venueDetails;
      booking.venueSetupId = { id: setup.id };
      this.selectedSetup = setup;
      booking.venueSectionId = { id: section.id };
      this.selectedSection = Object.assign(new VenueSection(), section);
      booking.venueTableId = { id: table.id };
      this.reservedTable = table;

      booking.bookingState = BOOKING_STATE.VenueConfirmed;
      if (isWalkIn) booking.setAsWalkIn();
      let bookingCustomer = new BookingCustomer();
      booking.guestCount = 2;
      booking.arrival = moment(date).toJSON();

      this.bookingCustomer = bookingCustomer;
      this.booking = booking;

      await this.setDataFromScoredTableResult(); //minimumspend and table parts
    },
    updateBooking(enhancedBooking) {
      let clonedBooking = _.cloneDeep(enhancedBooking.booking);

      let clonedBookingCustomer = _.cloneDeep(enhancedBooking.bookingCustomer);
      clonedBooking.orderLines.forEach((orderLine) => {
        orderLine.unitPriceFormatted = orderLine.unitPrice.value / 100;
        this.$set(orderLine, "showEditItemPrice", false);
      });

      this.bookingCustomer = clonedBookingCustomer;
      this.booking = clonedBooking;
      this.selectedVenue = _.cloneDeep(this.venueDetails);
      this.selectedSetup = _.cloneDeep(enhancedBooking.reservedSetup);
      this.selectedSection = _.cloneDeep(enhancedBooking.reservedSection);
      if (enhancedBooking.minimumSpendAmount)
        this.minimumSpendAmount = _.cloneDeep(
          enhancedBooking.minimumSpendAmount
        );
      if (enhancedBooking.reservedTable)
        this.reservedTable = _.cloneDeep(enhancedBooking.reservedTable);
      if (enhancedBooking.reservedTableParts)
        this.reservedTableParts = _.cloneDeep(
          enhancedBooking.reservedTableParts
        );

    },
    clear() {
      //called by popup when closing
      this.bookingCustomer = undefined;
      this.booking = undefined;

      this.minimumSpendAmount = undefined;
      this.reservedTable = undefined;
      this.reservedTableParts = [];
      this.selectedVenue = null;
      this.selectedSetup = null;
      this.selectedSection = null;
    },
    async handleSectionSelected(venueSection) {
      this.selectedSection = venueSection;
    },
    handleSetupSelected(venueSetup) {
      this.selectedSetup = venueSetup;
    },
    handleVenueSelected(venueDetails) {
      this.selectedVenue = venueDetails;
    },
    handleEditingOrderLinesChanged(isEditingOrderLines) {
      this.isEditingOrderLines = isEditingOrderLines;
    },
    handleIsAddingNoteChanged(isAddingNote) {
      this.isAddingNote = isAddingNote;
    },
    hasCustomerMessage() {
      return !!this.booking.customerMessage;
    },
    parseBookingWarnings(validationTrail) {
      if (validationTrail && validationTrail.length > 0) {
        let hardLimitFails = validationTrail.filter((vt) => {
          return (
            vt.limitType === POLICY_LIMIT_TYPE.Hard &&
            vt.tagSet &&
            vt.tagSet.tagValue === "POLICIES_BROKEN"
          );
        });

        let softLimitFails = validationTrail.filter((vt) => {
          return (
            vt.limitType === POLICY_LIMIT_TYPE.Soft &&
            vt.tagSet &&
            vt.tagSet.tagValue === "POLICIES_SOFT_FAIL"
          );
        });

        let warningLimitFails = validationTrail.filter((vt) => {
          return (
            vt.limitType === POLICY_LIMIT_TYPE.Warning &&
            vt.tagSet &&
            vt.tagSet.tagValue === "POLICIES_WARNING"
          );
        });

        return {
          hardLimitFails: hardLimitFails || [],
          softLimitFails: softLimitFails || [],
          warningLimitFails: warningLimitFails || [],
        };
      }
    },
    async handleSaveBookingClick() {
      await this.saveBooking(false);
    },
    async saveBooking(acceptSoftWarnings) {
      this.$vs.loading();

      try {
        if (this.editingMode === EDITING_MODE.Create) {
          let createBookingCommand = QueryCommandFactory.getForAction(
            BOOKING_ACTIONS.CreateBooking,
            this.booking
          );
          if (!!this.bookingCustomer.name && this.validBookingCustomerInfo) {
            createBookingCommand.newCustomerInfo = this.bookingCustomer;
          }

          const result = await this.$store.dispatch(
            "marcomBooking/" + BOOKING_ACTIONS.CreateBooking,
            {
              createBookingCommand: createBookingCommand,
              acceptSoftWarnings: acceptSoftWarnings,
            }
          );
          this.booking = result.booking;

          this.$vs.notify({
            color: "success",
            title: "Booking created",
            text: "The booking was created",
          });
        } else {
          await this.$store.dispatch(
            "marcomBooking/" + BOOKING_ACTIONS.UpdateBooking,
            {
              booking: this.booking,
              acceptSoftWarnings: acceptSoftWarnings,
            }
          );
  
          if(this.bookingCustomer && this.bookingCustomer.isNewCustomer){
  
                await this.$store.dispatch(
              "marcomBooking/" + BOOKING_ACTIONS.UpdateBookingCustomer,
              {
                bookingId: this.booking.bookingId.id,
                bookingCustomer: this.bookingCustomer
               })
          }
          if(this.booking.host){
            await this.$store.dispatch(
              "marcomBooking/" + BOOKING_ACTIONS.AssignUserAsHost,
              {
                booking: this.booking,
                userId: this.booking.host.userId,
              }
            );
          }

          this.$vs.notify({
            color: "success",
            title: "Booking updated",
            text: "The booking was updated",
          });
        }

        this.$emit("booking-saved");
      } catch (err) {
        console.error(err);
        if (err.validationTrail && err.validationTrail.length > 0) {
          const parsedWarnings = this.parseBookingWarnings(err.validationTrail);
          if (
            parsedWarnings.softLimitFails.length > 0 ||
            parsedWarnings.hardLimitFails.length > 0
          ) {
            this.$refs.popupBookingPoliciesWarning.show(parsedWarnings);
          }
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "The booking was not created: " + err.detail,
          });
        }
      } finally {
        this.$vs.loading.close();
      }
    },
    async handleBookingWithWarningsAccepted() {
      await this.saveBooking(true);
    },
    handleBookingWithWarningsRejected() {
      //do nothing
    },
    async handleAcceptRequestClick() {
      this.$vs.loading();
      try {
        await this.$store.dispatch(
          "marcomBooking/" + BOOKING_ACTIONS.AcceptRequest,
          {
            booking: this.booking,
            acceptSoftWarnings: false,
          }
        );

        this.$vs.notify({
          color: "success",
          title: "Request accepted",
          text: "The Request was accepted",
        });
        this.$emit("booking-saved");
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Request was not accepted",
        });
      } finally {
        this.$vs.loading.close();
        this.$emit("booking-saved");
      }
    },
    handleRejectRequestClick() {
      this.showConfirmRejectRequestPopup = true;
    },
    async handleConfirmRejectRequestClick() {
      this.$vs.loading();
      try {
        await this.$store.dispatch(
          "marcomBooking/" + BOOKING_ACTIONS.RejectRequest,
          this.booking
        );

        this.$vs.notify({
          color: "success",
          title: "Request rejected",
          text: "The Request was rejected",
        });

        this.showConfirmRejectRequestPopup = false;
        this.$emit("booking-saved");
      } catch (err) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "The Request was not rejected",
        });
      } finally {
        this.$vs.loading.close();
        this.$emit("booking-saved");
      }
    },
    handleCancelRejectRequestClick() {
      this.showConfirmRejectRequestPopup = false;
    },
    async setDataFromScoredTableResult() {
      if (this.booking.venueSectionId) {
        this.$vs.loading();

        var availableTableCommand = {
          bookingId: this.booking.id,
          numPersons: this.booking.guestCount,
          arrival: this.booking.arrival,
          venueSectionId: this.booking.venueSectionId.id,
          acceptSoftWarnings: true,
        };

        let result;
        try {
          result = await this.$store.dispatch(
            "marcomBooking/" + BOOKING_ACTIONS.GetAvailableSectionTables,
            availableTableCommand
          );
          if (result) {
            const foundResult = result.find(
              (r) => r.table.id === this.reservedTable.id
            );
            if (foundResult) {
              this.minimumSpendAmount = foundResult.minimumSpendAmount;
              this.reservedTableParts = foundResult.tableParts;
            }
          }
        } catch (err) {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: "Error getting tables",
            text: "Getting tables for the chosen section, date and time failed.",
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    async setSelectedSetup() {
      this.$vs.loading();
      try {
        if (this.booking.arrival && this.booking.venueDetailsId) {
          const date = moment(this.booking.arrival);
          var setupQuery = {
            venueDetailsId: this.booking.venueDetailsId.id,
            dateTime: new Date(date.toJSON()),
          };

          const result = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.GetActiveSetup,
            setupQuery
          );
          if (result) {
            this.selectedSetup = result;
            this.booking.venueSetupId = { id: result.id };
          }
        }
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Error getting active setup",
          text: "Getting active setup and sections for the chosen date and time failed.",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    permissionsGranted() {
      if (this.editingMode === EDITING_MODE.Create) {
        return this.hasPermissionForActiveVenue(
          "vp.vp.booking.createbookings"
        );
      } else {
        return this.hasPermissionForActiveVenue(
          "vp.vp.booking.editbookings"
        );
      }
    },
    addCustomer(){
      if(!this.bookingCustomer){
          this.bookingCustomer = new BookingCustomer();
          this.bookingCustomer.isNewCustomer = true
        }
    },
     async handlePartialGuestArrival({booking, arrival}){     
     try {
          this.$vs.loading();
     
          const action = {value: ARRIVAL_STATE.Arrived, type: "ARRIVAL_STATE", name: "partial"}
          console.log(arrival)
          arrival.arrivalId  ? await this.$store.dispatch("marcomBooking/" + BOOKING_ACTIONS.UpdatePartialArrival, 
          {booking: booking, arrival: arrival}) : await this.$store.dispatch("marcomBooking/" + BOOKING_ACTIONS.AddPartialArrival, 
          {booking: booking, arrival: arrival})
                  


          const changeArrivalStateCommand = new ChangeArrivalStateCommand(
            this.booking,
            ARRIVAL_STATE.Arrived
          );
          await this.$store.dispatch(
            "marcomBooking/" + BOOKING_ACTIONS.ChangeArrivalState,
            changeArrivalStateCommand
          );
          this.$emit("booking-updated");
           this.$emit("booking-saved");


          this.$vs.notify({
            color: "success",
            title: "Booking changed arrival count",
            text: "Booking partial arrival changed",
          });
        } catch (err) {
          console.error(err);

          this.$vs.notify({
            color: "danger",
            title: "Booking partiavl arrival",
            text: "Oops, something went wrong",
          });
        } finally {
          this.$vs.loading.close();
        }
    },
     createdBy(){
       return this.booking.changeLog[0] ? this.booking.changeLog[0].user : "none"
    },
    createdDate(){
      console.log(this.booking.changeLog)
        return this.booking.changeLog[0] ? moment.utc(this.booking.changeLog[0].created).format("DD-MM-YYYY HH:mm") : "none"
    },

  
     
  },
  async mounted() {
      await this.$store.dispatch(
      "marcomBooking/" + BOOKING_ACTIONS.GetHosts
    );
    
  },
 


};
</script>

<style lang="scss" scoped>
.editing-booking-popup-content {
  @media only screen and (max-width: 1281px) {
  height: calc(100vh - 385px);
    
  }


  height: calc(100vh - 225px);
  overflow: auto;
  //margin-top: 10px;
  margin-bottom: 10px;
  
}
.log-content {
  height: calc(100vh);
}

.confirm-reject-request-popup {
  z-index: 55000;
}

.confirm-reject-request-popup::v-deep .vs-popup {
  width: 1080px;
  
}

.booking-section {
  background: #f8f8f8;
}

.text-red {
  color: #aa0000;
}
.text-green {
  color: #00891b;
}
</style>
